export default __webpack_public_path__ + "static/media/pg-50.8dcf6a19.jpg";